import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7955c24f&scoped=true"
import script from "./placeUnsubscription.js?vue&type=script&lang=js&external"
export * from "./placeUnsubscription.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=7955c24f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7955c24f",
  null
  
)

export default component.exports